import React, { useState, useEffect } from "react";
import List from "@material-ui/core/List";
import { useDispatch, useSelector } from "react-redux";
import { getProductsInFavorite, getUserId } from "../reducks/users/selectors";
import { FavoriteListItem } from "../components/products";
import { PrimaryButton, GreyButton } from "../components/UIkit";
import { useCallback } from "react";
import { push } from "connected-react-router";
import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  root: {
    margin: "0 auto",
    maxWidth: 512,
    width: "100%",
  },
}));
const FavoriteList = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const userId = useSelector(getUserId);
  // const selector = useSelector((state)=>state);
  const productsInFavoriteRedux = useSelector(getProductsInFavorite) || [];
  const [productsInFavorite, setProductInFavorite] = useState(
    productsInFavoriteRedux
  );
  useEffect(() => {
    const updatedProducts = productsInFavoriteRedux.map((productRedux) => {
      // 同じfavoriteIdを持つproductsInFavorite内のアイテムを探す
      const existingProduct = productsInFavorite.find(
        (p) => p.favoriteId === productRedux.favoriteId
      );
      // 既存の製品に備考があれば、その備考を使用する
      if (existingProduct && existingProduct.remarks) {
        return { ...productRedux, remarks: existingProduct.remarks };
      } else {
        return productRedux;
      }
    });
    setProductInFavorite(updatedProducts);
  }, [productsInFavoriteRedux]);

  //備考を更新する
  const updateProductItem = useCallback(
    (favoriteId, newRemarks, newQuantity) => {
      setProductInFavorite((currentProducts) => {
        return currentProducts.map((product) => {
          if (product.favoriteId === favoriteId) {
            return { ...product, remarks: newRemarks, quantity: newQuantity };
          }
          return product;
        });
      });
    },
    [setProductInFavorite]
  );

  return (
    <section className="c-section-wrapin">
      <h2 className="u-text__headline">ブックマーク</h2>
      <List className={classes.root}>
        {productsInFavoriteRedux.length > 0 &&
          productsInFavoriteRedux.map((product) => (
            <FavoriteListItem
              key={product.favoriteId}
              product={product}
              updateProductItem={(newRemarks, newQuantity) =>
                updateProductItem(product.favoriteId, newRemarks, newQuantity)
              }
              isEnableRemarks={true}
            />
          ))}
      </List>
      {/* <div className="module-spacer--medium"/>
            <div className="p-grid__column">
                <PrimaryButton label={"レジへ進む"} onClick={goToOrder}/>
                <div className="module-spacer-extra-extra-small"></div>
                <GreyButton label={"ショッピングを続ける"} onClick={backToTop}/>
            </div> */}
    </section>
  );
};

export default FavoriteList;
